import React from 'react';

import { CSSObject } from 'styled-components';

import { Menu, MenuItem } from '../layout';
import { MenuProps } from '../layout/Menu/Menu';
import {
  DefaultItem,
  GenericItem,
  GetItemProps,
  GetMenuProps,
  RenderMenuItem,
} from '../types';

type MultiSelectMenuProps<TItem extends GenericItem> = MenuProps & {
  menuItems: TItem[];
  getMenuProps: GetMenuProps;
  getItemProps: GetItemProps<TItem>;
  highlightedIndex: number;
  addSelectedItem: (item: TItem) => void;
  removeSelectedItem: (item: TItem) => void;
  renderMenuItem?: RenderMenuItem<TItem>;
  selectedItems?: TItem[];
};

/**
 * @deprecated Single and Multi select menus have been combined.  Use DropdownMenu instead
 */
const MultiSelectMenu = <TItem extends GenericItem>({
  menuItems,
  getItemProps,
  renderMenuItem = ({ item, ...itemProps }) => (
    <MenuItem
      {...itemProps}
      text={(item as unknown as DefaultItem).label}
      subtext={(item as unknown as DefaultItem).subtext}
    />
  ),
  selectedItems,
  highlightedIndex,
  addSelectedItem,
  removeSelectedItem,
  children,
  ...props
}: MultiSelectMenuProps<TItem>) => {
  return (
    <Menu {...props}>
      {menuItems.map((item, index) => {
        const { style, isSelected, ...itemProps } =
          getItemProps?.({ item }) || {};
        return renderMenuItem({
          key: index,
          style: style as CSSObject,
          ...itemProps,
          onClick: () => {
            isSelected ? removeSelectedItem(item) : addSelectedItem(item);
          },
          item,
          isMultiple: true,
          isHighlighted: highlightedIndex === index,
          isSelected,
        });
      })}
      {children}
    </Menu>
  );
};

export default MultiSelectMenu;
